import { Asset } from "../state/types";

type AssetWithDynamicImages = Asset & Record<string, any>;

const PRIMARY_BGR_IMAGE_FIELDS = [
  "imageBgr",
  "imageBgrPano",
  "imageBgBlur",
  "imageBgBlurExterior",
  "imageBgblur",
  "imageBgrBlur",
  "imageBlur",
];

const FALLBACK_BGR_IMAGE_FIELDS = [
  "imageBgrExterior",
  "imageBgrManual",
];

function readImageArray(asset: AssetWithDynamicImages, field: string): any[] {
  const value = asset[field];
  return Array.isArray(value) ? value : [];
}

function dedupeImages(images: any[]): any[] {
  const seen = new Set<string>();

  return images.filter((image) => {
    const key = image?.imageUrlCf || image?.imageUrl || JSON.stringify(image);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function getBgrCarouselImages(asset: Asset | null | undefined): any[] {
  if (!asset) return [];

  const dynamicAsset = asset as AssetWithDynamicImages;
  const primaryImages = PRIMARY_BGR_IMAGE_FIELDS.flatMap((field) => readImageArray(dynamicAsset, field));
  const fallbackImages = primaryImages.length > 0
    ? []
    : FALLBACK_BGR_IMAGE_FIELDS.flatMap((field) => readImageArray(dynamicAsset, field));

  return dedupeImages([...primaryImages, ...fallbackImages]);
}
